import React, { useMemo } from "react";
import { Box, Flex, Link, Text, useBreakpointValue } from "@chakra-ui/react";
import LandingPageTabs from "@/features/landing/components/common/Tabs";
import SVG from "react-inlinesvg";
import FeatureSectionContainer from "@/features/landing/components/common/FeatureSectionContainer";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { Trans } from "react-i18next";

interface Props {
  isSignedIn: boolean;
}

const tabLabels = ["my.tab_product_data", "my.tab_suppliers_recommendation"];

function LadingPageMyDashboardSection({ isSignedIn }: Props) {
  const [tabIndex, setTabIndex] = React.useState(0);
  // const linkUrl = isSignedIn ? "/my-dashboard" : "/auth/sign-in";
  // const iconSize = useBreakpointValue({ base: 20, lg: 24 });
  const { tTitle, i18n } = useI18nHelper();
  const isKor = i18n.language === "ko";
  const tabPanels = useMemo(
    () => [
      {
        src: `/images/landing-my-dash-chart${isKor ? "" : "-eng"}.webp`,
        alt: "screen example of my dashboard product data chart",
      },
      {
        src: `/images/landing-my-dash-providers${isKor ? "" : "-eng"}.webp`,
        alt: "screen example of my dashboard provider recommendation list",
      },
    ],
    [isKor]
  );

  return (
    <Flex
      as={"section"}
      aria-labelledby={"landing-my-dashboard-title"}
      background={"#F8F8F8"}
      paddingX={{
        base: "16px",
        lg: "24px",
      }}
    >
      <FeatureSectionContainer maxWidth={"1318px"} margin={"0 auto"}>
        <LandingPageTabs
          labels={tabLabels}
          panels={tabPanels}
          backgroundColor={"#FFFFFF"}
          onChange={(index) => {
            setTabIndex(index);
          }}
          index={tabIndex}
        />
        <Flex
          flexDirection={"column"}
          gap={{
            base: "12px",
            lg: "24px",
          }}
          flex={1}
          alignItems={{
            base: "center",
            md: "flex-start",
          }}
        >
          <Text
            color={"#1272EF"}
            fontSize={{
              base: "16px",
              lg: "24px",
            }}
            fontWeight={700}
            lineHeight={{
              base: "24px",
              lg: "32px",
            }}
            as={"h2"}
            id={"landing-my-dashboard-title"}
          >
            {tTitle("landing:my.title")}
          </Text>
          <Flex
            flexDirection={"column"}
            fontSize={{
              base: "28px",
              lg: "48px",
            }}
            fontWeight={700}
            textAlign={{
              base: "center",
              md: "start",
            }}
            lineHeight={{
              base: "38px",
              lg: "68px",
            }}
          >
            <Trans
              i18nKey={"landing:my.subtitle"}
              components={{
                br: <Box as={"span"} />,
              }}
            />
          </Flex>
          <Text
            fontSize={{
              base: "16px",
              lg: "24px",
            }}
            lineHeight={{
              base: "24px",
              lg: "32px",
            }}
            color={"#737373"}
            textAlign={{
              base: "center",
              md: "start",
            }}
          >
            <Trans
              i18nKey={"landing:my.description"}
              components={{
                br: (
                  <Box
                    as={"span"}
                    display={{
                      base: "none",
                      md: "block",
                    }}
                  />
                ),
              }}
            />
          </Text>
        </Flex>
      </FeatureSectionContainer>
    </Flex>
  );
}

export default LadingPageMyDashboardSection;
